import { createGlobalStyle } from 'styled-components';

// react-ux <Layout> renders a fixed-height petrol accent line (height: 0.4rem) between the
// app header and the content area. It ships with the browser default flex-shrink: 1, so inside
// the full-height app column it becomes the only shrinkable item (the content area is
// `flex: 1 1 0%`, basis 0, and does not participate in shrink). It therefore absorbs the
// column's sub-pixel overflow and collapses to a <1px sliver whose fractional height changes
// on every relayout. That jitter shifts all page content by ~1px — e.g. when switching to the
// Case Details "Workflow" tab (DD-133).
//
// Pinning the bar with flex-shrink: 0 keeps it at its intended height (per the project rule for
// library-rendered fixed-height bars), so it no longer absorbs sub-pixel remainder and the
// content stops shifting. The remainder is taken from the flex-grow content area instead, which
// has its own inner scroller and is unaffected visually.
export const AppLayoutFix = createGlobalStyle`
  #root > .ant-layout > div {
    flex-shrink: 0;
  }
`;
